var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sr-steps"},[_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,class:['item', _vm.active >= index ? 'active' : '']},[_c('span',[_vm._v(_vm._s(index + 1))]),_vm._v(" "+_vm._s(step)+" ")])}),_c('div',{staticClass:"line",style:(`width: ${(_vm.active + 1) * (100 / _vm.steps.length).toFixed(2)}%; `)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }